import { IMessageHandler } from "../message-handler";
import { IHandlerContext } from "../handler-context";
import { StorageMessage, StorageResponse } from "../../crypto/crypto-types";

interface ExportUserRequest {
  userId: string;
}

interface ExportUserResponse {
  exportData: any;
  filename: string;
}

export class ExportUserHandler implements IMessageHandler<ExportUserRequest> {
  constructor(private context: IHandlerContext) {}

  canHandle(type: string): boolean {
    return type === "EXPORT_USER";
  }

  async handle(message: StorageMessage<ExportUserRequest>, source: Window, origin: string): Promise<void> {
    const { userId } = message.data;

    if (!userId) {
      this.context.sendError(source, 'User ID required', 'MISSING_USER_ID', origin, message.requestId);
      return;
    }

    const exportData = await this.context.dbService.exportUserData(userId);
    // Create encrypted backup blob
    const backupData = {
      version: 1,
      exportDate: new Date().toISOString(),
      userData: exportData
    };

    const response: StorageResponse<ExportUserResponse> = {
      type: 'RESPONSE',
      data: {
        exportData: backupData,
        filename: `crypto-portfolio-backup-${userId.slice(0, 8)}-${new Date().toISOString().split('T')[0]}.json`
      },
      requestId: message.requestId
    };
    this.context.sendResponse(source, response, origin, message.requestId);
  }
}
